import { render, staticRenderFns } from "./ProfileOverlay.vue?vue&type=template&id=3e8029d7&scoped=true&"
import script from "./ProfileOverlay.vue?vue&type=script&lang=js&"
export * from "./ProfileOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOverlay.vue?vue&type=style&index=0&id=3e8029d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8029d7",
  null
  
)

export default component.exports